import UserChangePasswordAdmin from './user-change-password-admin';

export default UserChangePasswordAdmin;